/* Matrix Forex hero form. Extracted verbatim from snippets/hero-form.liquid
   (Phase 2, Aug 2026) so it caches across pages instead of shipping inline
   in every HTML response. The only source change: OTP_WORKER_URL now reads
   window.HF_OTP_URL, set by a one-line inline script in the snippet. */

/*  ─────────────────────────────────────────────────────────────────────────
    HERO FORM RUNTIME

    This snippet can render several times on one page (page-forex-services
    renders it five times). Everything below is therefore scoped to ONE card:
    each .hf-hero-card gets its own DOM refs, its own active tab, its own
    calculator and its own validators, and inits exactly once.

    Duplicate element ids across cards are intentional and unchanged — GTM
    reads the id attribute off the submitted element, so its triggers keep
    matching. Lookups here use card.querySelector('#id'), which searches only
    that card's subtree, so duplicates resolve to the right card.

    Page-level work that must happen ONCE (rate fetch, consent modal,
    geolocation, the post-submit conversion push) is guarded by window flags
    and a shared rate store.
    ───────────────────────────────────────────────────────────────────────── */
(function(){
'use strict';

/* ── CONFIG ─────────────────────────────────────────────────── */
var OTP_ENABLED    = false;
var OTP_WORKER_URL = window.HF_OTP_URL || '';

/* ── CONSTANTS ──────────────────────────────────────────────── */
var ALLOWED = new Set([
  'AED','AUD','BDT','CAD','CHF','CNY','CZK','DKK',
  'EUR','GBP','HKD','IDR','JPY','KRW','LKR','MUR',
  'MYR','NOK','NZD','QAR','RUB','SAR','SEK','SGD',
  'THB','USD','VND','ZAR'
]);

/* ── Minimum order qty per currency (in FX units) ── */
var MIN_QTY = {
  AED:500,    AUD:200,    BDT:5000,   CAD:200,
  CHF:200,    CNY:500,    CZK:500,    DKK:500,
  EUR:200,    GBP:200,    HKD:500,    IDR:500000,
  JPY:10000,  KRW:50000,  LKR:5000,   MUR:1000,
  MYR:500,    NOK:500,    NZD:200,    QAR:500,
  RUB:2000,   SAR:500,    SEK:500,    SGD:200,
  THB:2000,   USD:200,    VND:500000, ZAR:500
};
var DEFAULT_MIN = 200;

/* ── CURRENCY META — name, flag and search keywords ─────────────
   `k` powers the typeahead: users can search by currency name
   ("thai baht"), code ("THB"), country ("thailand") or city
   ("bangkok"). Keys must stay in sync with ALLOWED above.       */
var CCY = {
  AED:{ n:'UAE Dirham',           f:'🇦🇪', k:'uae united arab emirates dirham dubai abu dhabi sharjah gulf' },
  AUD:{ n:'Australian Dollar',    f:'🇦🇺', k:'australia aussie sydney melbourne perth brisbane oz' },
  BDT:{ n:'Bangladeshi Taka',     f:'🇧🇩', k:'bangladesh taka dhaka chittagong' },
  CAD:{ n:'Canadian Dollar',      f:'🇨🇦', k:'canada loonie toronto vancouver montreal calgary' },
  CHF:{ n:'Swiss Franc',          f:'🇨🇭', k:'switzerland swiss franc zurich geneva bern interlaken' },
  CNY:{ n:'Chinese Yuan',         f:'🇨🇳', k:'china chinese renminbi rmb yuan beijing shanghai guangzhou' },
  CZK:{ n:'Czech Koruna',         f:'🇨🇿', k:'czech czechia republic koruna crown prague' },
  DKK:{ n:'Danish Krone',         f:'🇩🇰', k:'denmark danish krone crown copenhagen' },
  EUR:{ n:'Euro',                 f:'🇪🇺', k:'euro europe eurozone schengen france germany italy spain netherlands portugal greece austria belgium ireland finland paris rome berlin amsterdam' },
  GBP:{ n:'British Pound',        f:'🇬🇧', k:'uk united kingdom britain british england scotland wales pound sterling quid london manchester edinburgh' },
  HKD:{ n:'Hong Kong Dollar',     f:'🇭🇰', k:'hong kong hk hongkong' },
  IDR:{ n:'Indonesian Rupiah',    f:'🇮🇩', k:'indonesia indonesian rupiah bali jakarta lombok ubud' },
  JPY:{ n:'Japanese Yen',         f:'🇯🇵', k:'japan japanese yen tokyo osaka kyoto' },
  KRW:{ n:'South Korean Won',     f:'🇰🇷', k:'korea korean south won seoul busan' },
  LKR:{ n:'Sri Lankan Rupee',     f:'🇱🇰', k:'sri lanka lankan ceylon rupee colombo kandy galle' },
  MUR:{ n:'Mauritian Rupee',      f:'🇲🇺', k:'mauritius mauritian rupee port louis' },
  MYR:{ n:'Malaysian Ringgit',    f:'🇲🇾', k:'malaysia malaysian ringgit kuala lumpur penang langkawi' },
  NOK:{ n:'Norwegian Krone',      f:'🇳🇴', k:'norway norwegian krone crown oslo bergen tromso' },
  NZD:{ n:'New Zealand Dollar',   f:'🇳🇿', k:'new zealand kiwi auckland wellington queenstown' },
  QAR:{ n:'Qatari Riyal',         f:'🇶🇦', k:'qatar qatari riyal rial doha' },
  RUB:{ n:'Russian Ruble',        f:'🇷🇺', k:'russia russian ruble rouble moscow st petersburg' },
  SAR:{ n:'Saudi Riyal',          f:'🇸🇦', k:'saudi arabia arabian riyal rial riyadh jeddah mecca medina umrah hajj' },
  SEK:{ n:'Swedish Krona',        f:'🇸🇪', k:'sweden swedish krona crown stockholm gothenburg' },
  SGD:{ n:'Singapore Dollar',     f:'🇸🇬', k:'singapore singaporean sing' },
  THB:{ n:'Thai Baht',            f:'🇹🇭', k:'thailand thai baht bangkok phuket pattaya krabi chiang mai' },
  USD:{ n:'US Dollar',            f:'🇺🇸', k:'usa us united states america american dollar buck greenback new york' },
  VND:{ n:'Vietnamese Dong',      f:'🇻🇳', k:'vietnam vietnamese dong hanoi ho chi minh saigon da nang' },
  ZAR:{ n:'South African Rand',   f:'🇿🇦', k:'south africa african rand johannesburg cape town durban' }
};
var POPULAR = ['USD','EUR','GBP','AUD','CAD','SGD','AED','THB'];

/* Currencies the remittance desk quotes. Single source of truth — this list
   used to be repeated at each call site, which is how AED ended up surviving
   in one place after being dropped in another. Mirrors REMIT_ONLY in rates.js. */
var REMIT_CCY = ['USD','EUR','GBP','CAD','AUD','SGD','NZD'];

/* ── BRANCH CITIES — the only service areas we take orders for ──
   `label` is what the dropdown and the field show. `value` is the branch name
   submitted as contact[city] and printed in the lead email.
   `k` maps a geolocated place onto the right service area. */
var CITIES = [
  { label:'Delhi & NCR',           value:'Delhi',
    k:'delhi new delhi ncr gurgaon gurugram noida greater noida faridabad ghaziabad dwarka saket rohini' },
  { label:'Mumbai (MMR)',          value:'Mumbai',
    k:'mumbai bombay mmr navi mumbai thane andheri bandra powai borivali kalyan dombivli vasai virar mira bhayandar panvel' },
  { label:'Bengaluru',             value:'Bangalore',
    k:'bengaluru bangalore koramangala indiranagar whitefield electronic city hsr layout marathahalli jayanagar' },
  { label:'Hyderabad',             value:'Hyderabad',
    k:'hyderabad secunderabad telangana hitech city gachibowli kondapur madhapur kukatpally' },
  { label:'Pune',                  value:'Pune',
    k:'pune poona pimpri chinchwad hadapsar magarpatta hinjewadi kothrud wakad baner' },
  { label:'Chennai',               value:'Chennai',
    k:'chennai madras royapettah tambaram velachery adyar omr anna nagar' },
  { label:'Kanpur & Lucknow',      value:'Kanpur',
    k:'kanpur lucknow kanpur nagar uttar pradesh gomti nagar hazratganj' },
  { label:'Tiruppur & Coimbatore', value:'Tiruppur',
    k:'tiruppur tirupur coimbatore kovai avinashi peelamedu saibaba colony' }
];

/* The picker shows the full service-area label so a customer in Noida or
   Coimbatore can see they're covered. The lead that reaches the team should
   name the branch instead — "Delhi", not "Delhi & NCR". The swap happens at
   submit time in normaliseCityForSubmit(), so what the customer sees on
   screen never changes. */
function branchNameFor(label){
  for (var i = 0; i < CITIES.length; i++) {
    if (CITIES[i].label === label) return CITIES[i].value;
  }
  return label;
}

/* ── SMALL HELPERS ──────────────────────────────────────────── */
function norm(s){ return (s || '').toString().toLowerCase().trim().replace(/\s+/g, ' '); }
function esc(s){
  return String(s).replace(/[&<>"']/g, function(c){
    return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c];
  });
}
function rateDp(code){
  if (code === 'VND' || code === 'IDR') return 6;
  if (code === 'JPY' || code === 'KRW' || code === 'LKR' || code === 'BDT') return 4;
  return 2;
}
function precision(code){ return code === 'VND' ? 6 : code === 'JPY' ? 3 : 4; }

/* ══════════════════════════════════════════════════════════════
   SHARED RATE STORE
   One fetch per page no matter how many cards render. Cards
   subscribe and repaint when rates land.
   ══════════════════════════════════════════════════════════════ */
var STORE = window.__hfRateStore || (window.__hfRateStore = {
  table: {}, updated: '', failed: false, started: false, subs: []
});
function ratesReady(){ for (var k in STORE.table) return true; return false; }
function onRates(fn){
  STORE.subs.push(fn);
  if (ratesReady() || STORE.failed) { try { fn(); } catch(e){} }
}
function emitRates(){
  STORE.subs.forEach(function(f){ try { f(); } catch(e){} });
}
function startRates(){
  if (STORE.started) return;
  STORE.started = true;

  /* assets/rates.js (window.MatrixRates) is the ONE rate source for the whole
     site. The form must not call the rate worker itself — that fired a second
     identical request on every page that renders this card. MatrixRates applies
     the same margins and caches to localStorage, so the numbers are identical. */
  function syncFromGlobal(){
    if (!window.MatrixRates) return;
    var all = window.MatrixRates.getAll();
    if (all && Object.keys(all).length) {
      STORE.table   = all;
      STORE.failed  = false;
      STORE.updated = new Date().toLocaleTimeString();
      emitRates();
    }
  }

  syncFromGlobal();
  if (window.MatrixRates) window.MatrixRates.onReady(syncFromGlobal);
  document.addEventListener('matrix-rates-ready', syncFromGlobal);

  /* rates.js stays silent when its fetch fails and it has no cache, so without
     this the ticker would sit on "Connecting…" forever. */
  setTimeout(function(){
    if (!ratesReady()) { STORE.failed = true; emitRates(); }
  }, 9000);
}

/* ══════════════════════════════════════════════════════════════
   TRAFFIC SOURCE CAPTURE  (computed once per page)
   Captures every signal we can use to disambiguate:
     Google Ads  →  ?gclid / ?gbraid / ?wbraid (Google appends these)
     Manual UTM  →  ?utm_source / ?utm_medium / ?utm_campaign
     Meta        →  ?fbclid (Meta uses a separate landing page)
     Organic     →  referrer matches a search engine, no click ID present
     Direct      →  no referrer, no params, no stored session signals
   Everything is persisted to sessionStorage so a multi-step session
   (land → browse → submit) still carries the original source.
   ══════════════════════════════════════════════════════════════ */
var trackingData = window.__hfTracking || (window.__hfTracking = (function () {
  var t = {};
  var p = new URLSearchParams(window.location.search);
  var KEYS = [
    'gclid', 'gbraid', 'wbraid', 'fbclid', 'rdt_cid', 'oppref',
    'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'campaign_id', 'cid', 'gad_campaignid'
  ];
  KEYS.forEach(function (k) {
    var fromUrl = p.get(k);
    if (fromUrl) {
      t[k] = fromUrl;
      try { sessionStorage.setItem('mx_' + k, fromUrl); } catch (e) {}
    } else {
      try {
        var stored = sessionStorage.getItem('mx_' + k);
        if (stored) t[k] = stored;
      } catch (e) {}
    }
  });
  /* First-touch referrer, stored once per session. */
  try {
    var firstRef = sessionStorage.getItem('mx_first_referrer');
    if (!firstRef) {
      firstRef = document.referrer || '';
      sessionStorage.setItem('mx_first_referrer', firstRef);
    }
    t.referrer = firstRef;
  } catch (e) {
    t.referrer = document.referrer || '';
  }
  return t;
})());

/* Classify lead source from captured signals (priority order). */
function classifySource() {
  var t = trackingData;
  if (t.gclid)  return 'Google Ads';
  if (t.gbraid) return 'Google Ads (iOS app)';
  if (t.wbraid) return 'Google Ads (Android app)';
  if (t.fbclid) return 'Meta Ads';
  if (t.rdt_cid) return 'Reddit Ads';
  if (t.oppref) return 'ChatGPT Ads';
  if (t.utm_source) {
    var s = (t.utm_source + '').toLowerCase();
    var m = (t.utm_medium || '').toLowerCase();
    if (s === 'google' && (m === 'cpc' || m === 'paid' || m === 'ads')) return 'Google Ads (UTM)';
    if (s === 'facebook' || s === 'meta' || s === 'instagram') return 'Meta Ads (UTM)';
    if (s === 'reddit') return 'Reddit Ads (UTM)';
    return 'Campaign: ' + t.utm_source + (m ? ' / ' + m : '');
  }
  var ref = (t.referrer || '').toLowerCase();
  if (ref.indexOf('google.') > -1)     return 'Google Organic';
  if (ref.indexOf('bing.') > -1)       return 'Bing Organic';
  if (ref.indexOf('facebook.') > -1 || ref.indexOf('fb.') > -1) return 'Facebook Referral';
  if (ref.indexOf('instagram.') > -1)  return 'Instagram Referral';
  if (ref.indexOf('linkedin.') > -1)   return 'LinkedIn Referral';
  if (ref.indexOf('youtube.') > -1)    return 'YouTube Referral';
  if (ref.indexOf('whatsapp.') > -1 || ref.indexOf('wa.me') > -1) return 'WhatsApp Referral';
  if (ref && ref.indexOf(window.location.hostname) === -1) return 'Referral: ' + ref;
  return 'Direct';
}

/* Rewrite contact[city] from the displayed service-area label to the branch
   name, just before the form serialises. Runs inside the capture-phase submit
   handler, which fires only after native validation has passed — so the value
   the customer saw on screen is never altered while they're still filling it
   in, and Shopify receives "Delhi" rather than "Delhi & NCR". */
function normaliseCityForSubmit(formEl){
  var el = formEl.querySelector('[name="contact[city]"]');
  if (el && el.value) el.value = branchNameFor(el.value.trim());
}

/* Google Ads EC-for-Leads: stash phone (E.164) before Shopify's post-submit
   reload, so we can fire the lead conversion on the way back. Every form
   that submits successfully calls this — Buy, Sell and Send alike. */
function stashLeadPhone(formEl){
  /* Which tab this lead came from, so the post-reload confirmation matches. */
  try {
    var MODE_OF = { hfBuyForm:'buy', hfSellForm:'sell', hfSendForm:'send' };
    if (MODE_OF[formEl.id]) sessionStorage.setItem('hfLeadMode', MODE_OF[formEl.id]);
    /* Separate copy for the confirmation message — hfLeadPhone below is
       consumed by the conversion push and must not be read for anything else. */
    var showDigits = String((formEl.querySelector('[name="contact[phone]"]') || {}).value || '').replace(/\D/g, '').slice(-10);
    if (showDigits.length === 10) sessionStorage.setItem('hfLeadPhoneShow', showDigits);
  } catch (err) {}

  var hfPhone = (formEl.querySelector('[name="contact[phone]"]') || {}).value || '';
  var hfDigits = String(hfPhone).replace(/\D/g, '');
  if (hfDigits.length > 10) hfDigits = hfDigits.slice(-10);
  if (hfDigits.length === 10) {
    try { sessionStorage.setItem('hfLeadPhone', '+91' + hfDigits); } catch (err) {}
  }
}

/* ══════════════════════════════════════════════════════════════
   PANEL REGISTRY — page-wide, so opening a dropdown in one card
   closes any dropdown open in another.
   ══════════════════════════════════════════════════════════════ */
var openPanels = window.__hfPanels || (window.__hfPanels = []);
function closeAllPanels(){ openPanels.forEach(function(p){ try { p.close(); } catch(e){} }); }

if (!window.__hfPanelListeners) {
  window.__hfPanelListeners = true;

  document.addEventListener('mousedown', function(e){
    openPanels.forEach(function(p){
      if (p.el.hidden) return;
      /* The panel is portaled into <body>, so it is NOT a descendant of the
         host — both have to be checked or clicking a row would close it. */
      if (!p.host.contains(e.target) && !p.el.contains(e.target)) p.close();
    });
  });
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' || e.key === 'Esc') {
      var modal = document.getElementById('hfConsentModal');
      if (modal && modal.classList.contains('active')) return;  /* modal owns Esc */
      closeAllPanels();
    }
  });

  /* Only react to WIDTH changes. On mobile, focusing a panel's search box
     raises the soft keyboard, which fires `resize` with a shorter viewport —
     closing on that would slam the panel shut the moment it was tapped. */
  var lastVw = window.innerWidth;
  window.addEventListener('resize', function(){
    if (window.innerWidth === lastVw) return;
    lastVw = window.innerWidth;
    closeAllPanels();
  });
}

/* How much room a dropdown wants below its field before we consider the
   position cramped. Roughly a full city list / six currency rows. */
var PANEL_ROOM = 280;

/* Scroll without the page's CSS smooth-scrolling, so the panel can be measured
   and placed in the same frame. */
function scrollByInstant(dy){
  var el = document.documentElement;
  var prev = el.style.scrollBehavior;
  el.style.scrollBehavior = 'auto';
  window.scrollBy(0, dy);
  el.style.scrollBehavior = prev;
}

/* A dropdown belongs BELOW its field — that is what people expect, and opening
   upwards covers the fields they have already filled in. So when the field sits
   too low, nudge the page down to create room instead of flipping the panel.
   Only when the page cannot scroll any further does the panel go above. */
function ensureRoomBelow(host){
  var r     = host.getBoundingClientRect();
  var below = window.innerHeight - r.bottom - 15;
  if (below >= PANEL_ROOM) return;

  var doc       = document.documentElement;
  var maxScroll = (doc.scrollHeight - window.innerHeight) - (window.pageYOffset || doc.scrollTop || 0);
  var by        = Math.min(PANEL_ROOM - below, Math.max(0, maxScroll));
  /* Never scroll so far that the field itself leaves the screen. */
  by = Math.min(by, Math.max(0, r.top - 8));
  if (by > 4) scrollByInstant(by);
}

/* Position a portaled panel in viewport coordinates.

   The panel lives in <body> and is position:fixed, so none of the
   overflow:hidden ancestors between it and the card (.hero-v7,
   .hero-glass-shell, .hf-hero-card) can clip it.

   opts.remeasure === false  → only move it (cheap, used while the page
   scrolls). Re-measuring clears the list's max-height, and doing that on
   every scroll tick resets the list's scroll position, which made the
   lower entries impossible to reach on touch devices. */
function positionPanel(panel, host, opts){
  var remeasure = !opts || opts.remeasure !== false;
  var GAP  = 7;
  var EDGE = 8;                       /* keep clear of the viewport edges */
  var r    = host.getBoundingClientRect();
  var vw   = document.documentElement.clientWidth;
  var vh   = window.innerHeight;
  var list = panel.querySelector('.hf-ccy-list, .hf-city-list');

  /* Match the field's width, but never overflow the viewport. */
  var width = Math.min(r.width, vw - EDGE * 2);
  panel.style.width = Math.round(width) + 'px';
  panel.style.left  = Math.round(Math.min(Math.max(r.left, EDGE), vw - width - EDGE)) + 'px';

  /* Downwards unless there is genuinely no usable room there. ensureRoomBelow()
     has already tried to scroll room into existence before we get here. */
  var below    = vh - r.bottom - GAP - EDGE;
  var above    = r.top - GAP - EDGE;
  var useAbove = (below < 180 && above > below);
  var space    = Math.max(useAbove ? above : below, 140);

  if (remeasure && list) {
    var keep = list.scrollTop;
    list.style.maxHeight = '';                 /* measure at natural height */
    var natural = panel.offsetHeight;
    if (natural > space) {
      var chrome = natural - list.offsetHeight;   /* search box, header… */
      list.style.maxHeight = Math.max(120, space - chrome) + 'px';
    }
    list.scrollTop = keep;                     /* never lose the scroll position */
  }

  /* Final clamp: the panel is always fully on screen. */
  var h   = panel.offsetHeight;
  var top = useAbove ? (r.top - GAP - h) : (r.bottom + GAP);
  top = Math.min(Math.max(top, EDGE), Math.max(EDGE, vh - h - EDGE));
  panel.style.top = Math.round(top) + 'px';
}

/* Keep an open panel glued to its field while the page moves. Capture phase
   so scrolling inside any nested container counts too. */
function trackPanel(panel, host){
  var raf = 0;
  function follow(e){
    if (panel.hidden) return;
    /* Scrolling the panel's OWN list is not page movement — reacting to it
       would re-measure and throw the list back to the top. */
    if (e && e.target && e.target.nodeType === 1 && panel.contains(e.target)) return;
    if (raf) return;
    raf = requestAnimationFrame(function(){
      raf = 0;
      if (!panel.hidden) positionPanel(panel, host, { remeasure: false });
    });
  }
  function relayout(){ if (!panel.hidden) positionPanel(panel, host); }
  window.addEventListener('scroll', follow, true);
  window.addEventListener('resize', relayout);
}

var uidSeq = 0;

/* Score a currency against the query. Higher is better, 0 = no match. */
function scoreCcy(code, q){
  if (!q) return 1;
  var meta = CCY[code] || { n:code, k:'' };
  var name = norm(meta.n);
  var low  = code.toLowerCase();

  if (low === q)                    return 100;
  if (low.indexOf(q) === 0)         return 90;
  if (name.indexOf(q) === 0)        return 80;
  /* word-start match inside the name: "dollar" hits "US Dollar" */
  if ((' ' + name).indexOf(' ' + q) > -1) return 70;
  if (name.indexOf(q) > -1)         return 60;
  if (low.indexOf(q) > -1)          return 50;
  if ((' ' + meta.k).indexOf(' ' + q) > -1) return 40;
  if (meta.k.indexOf(q) > -1)       return 30;
  return 0;
}

/* Everything we're licensed to quote, whether or not a live rate has landed
   yet — the list must never look empty while loading. */
function ccyCodes(){
  return Object.keys(CCY).filter(function(c){ return ALLOWED.has(c); });
}

/* ══════════════════════════════════════════════════════════════
   PER-CARD SETUP
   ══════════════════════════════════════════════════════════════ */
function initCard(card){
  if (card.__hfInit) return;
  card.__hfInit = true;

  /* ── STATE (per card) ── */
  var activeMode = card.dataset.defaultTab || 'buy';
  /* Landing back from a successful submit: open the tab it came from. */
  if (window.__hfDone && window.__hfDone.mode) activeMode = window.__hfDone.mode;
  var pickerRefreshers = [];
  var formValidators   = {};

  /* ── DOM REFS (scoped to this card) ── */
  var selCurrency   = card.querySelector('#hfFromCurrency');
  var inpAmount     = card.querySelector('#hfFromAmount');
  var elValue       = card.querySelector('#hfConvertedValue');
  var elRate        = card.querySelector('#hfDisplayRate');
  var elMarquee     = card.querySelector('#hfMarqueeInner');
  var elUpdated     = card.querySelector('#hfLastUpdated');
  var elTickerLabel = card.querySelector('.hf-ticker-label');
  var warnEl        = card.querySelector('#hfMinWarning');
  var line1         = card.querySelector('#hfMinLine1');
  var line2         = card.querySelector('#hfMinLine2');
  var tabs          = card.querySelectorAll('.hf-tab');
  var formWraps     = {
    buy:  card.querySelector('.hf-form-wrap--buy'),
    sell: card.querySelector('.hf-form-wrap--sell'),
    send: card.querySelector('.hf-form-wrap--send')
  };

  function refreshPickers(){
    pickerRefreshers.forEach(function(fn){ try { fn(); } catch(e){} });
  }

  /* ── Confirmation panel, scoped to the submitted form ────────── */
  if (window.__hfDone) {
    var doneForm = card.querySelector('#hf' + {buy:'Buy',sell:'Sell',send:'Send'}[window.__hfDone.mode] + 'Form');
    var doneFb   = doneForm && doneForm.querySelector('.hf-form-feedback');
    if (doneFb) {
      doneFb.classList.add('is-visible');
      var ph = doneFb.querySelector('[data-hf-done-phone]');
      if (ph && window.__hfDone.phone) {
        /* Show the number back so a typo is obvious while it can still be fixed. */
        ph.textContent = window.__hfDone.phone.replace(/(\d{5})(\d{5})/, '$1 $2');
        doneFb.querySelector('.hf-form-feedback__phone').hidden = false;
      }
    }
  }

  /* ── Initial form-wrap visibility based on activeMode ────────── */
  Object.keys(formWraps).forEach(function(k){
    if (formWraps[k]) formWraps[k].style.display = (k === activeMode) ? 'block' : 'none';
  });
  /* The active pill is set in Liquid from default_tab, so when a post-submit
     reload overrides activeMode the highlight has to be moved to match. */
  tabs.forEach(function(b){ b.classList.toggle('hf-tab--active', b.dataset.mode === activeMode); });

  /* ── MODE LABELS ─────────────────────────────────────────────── */
  var MODE_COPY = {
    buy:  { from:'You buy',  total:'Total cost',
            note:'Free doorstep delivery, or collect from your branch',
            foot:'RBI-authorised \u00B7 Pay only on delivery \u00B7 No spam',
            popH:'How delivery works',
            popList:['Free doorstep delivery across 16 cities, or collect from your branch',
                     'Pay on delivery — nothing is charged when you submit this form',
                     'Cash, forex card, or both together'],
            popNote:'' },
    sell: { from:'You sell', total:'You receive',
            note:'Doorstep pickup \u00B7 Paid out in cash or to your bank',
            foot:'RBI-authorised \u00B7 FEMA compliant \u00B7 No spam',
            popH:'How selling works',
            popList:['We collect the currency from your doorstep, or you drop it at a branch',
                     'Take the payout in cash on the spot, or straight to your bank account',
                     'Notes must be undamaged'],
            popNote:'' },
    send: { from:'You send', total:'You pay',
            note:'Bank & service charges applied at checkout',
            foot:'RBI-authorised \u00B7 Rate confirmed on call \u00B7 No spam',
            popH:'Charges at checkout',
            popList:['Correspondent (nostro) bank charge \u2014 set by your university\u2019s bank',
                     'Matrix service fee',
                     'TCS under LRS, where it applies to you'],
            popNote:'Your officer confirms every charge on the call, before anything is booked. Your university still receives the full amount you entered above.' }
  };
  function syncModeLabels(){
    var copy = MODE_COPY[activeMode] || MODE_COPY.buy;
    card.querySelectorAll('[data-hf-total-label]').forEach(function(el){ el.textContent = copy.total; });
    card.querySelectorAll('[data-hf-from-label]').forEach(function(el){ el.textContent = copy.from;  });
    card.querySelectorAll('[data-hf-note]').forEach(function(el){ el.textContent = copy.note;  });
    card.querySelectorAll('[data-hf-foot] span').forEach(function(el){ el.textContent = copy.foot; });
    syncPop(copy);
  }

  /* Send mode hides every rate-derived element. Driven by one class so the
     markup and the CSS stay in one place. */
  function syncModeUI(){
    card.classList.toggle('hf-mode-send', activeMode === 'send');
    /* The confirmation belongs to the tab it was submitted from. Switch to a
       different product and you get that product's form as normal; come back
       and the confirmation is still there. */
    var done = window.__hfDone;
    card.classList.toggle('hf-card--done', !!done && activeMode === done.mode);
  }

  /* ── CHARGES POPOVER ───────────────────────────────────────────
     .hero-form-wrap carries a backdrop-filter, which makes it a containing
     block for position:fixed children — so the popover was being positioned
     inside the plinth and then clipped by .hero-v7{overflow:hidden}. Moving
     it to <body> on init is what makes it actually appear. */
  (function reparentPop(){
    /* One render emits one popover; a page with several cards emits several,
       all sharing an id. Keep the first, drop the rest — same treatment the
       consent modal gets below — then move it to <body> so position:fixed
       isn't trapped by the plinth's backdrop-filter. */
    document.querySelectorAll('#hfPop').forEach(function (el, i) {
      if (i > 0 && el.parentNode) el.parentNode.removeChild(el);
    });
    var pop = document.getElementById('hfPop');
    if (pop && pop.parentNode !== document.body) document.body.appendChild(pop);
  })();

  function syncPop(copy){
    var pop = document.getElementById('hfPop');
    if (!pop || !copy) return;
    document.getElementById('hfPopH').textContent = copy.popH || '';
    document.getElementById('hfPopList').innerHTML =
      (copy.popList || []).map(function(x){ return '<li>' + esc(x) + '</li>'; }).join('');
    var n = document.getElementById('hfPopNote');
    n.textContent = copy.popNote || '';
    n.style.display = copy.popNote ? '' : 'none';
    pop.hidden = true;
  }
  card.addEventListener('click', function(e){
    var btn = e.target.closest('[data-hf-info]');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    var pop = document.getElementById('hfPop');
    if (!pop.hidden) { pop.hidden = true; return; }
    pop.hidden = false;
    var r = btn.getBoundingClientRect();
    var left = Math.min(window.innerWidth - 310, Math.max(14, r.left - 140));
    var top  = r.bottom + 10;
    if (top + pop.offsetHeight > window.innerHeight - 14) top = Math.max(14, r.top - pop.offsetHeight - 10);
    pop.style.left = left + 'px';
    pop.style.top  = top + 'px';
  });

  /* Typing the wrong number is the one mistake a customer can't undo once the
     form is gone, so give them the way back rather than only the bad news. */
  card.addEventListener('click', function(e){
    if (!e.target.closest('[data-hf-redo]')) return;
    e.preventDefault();
    window.__hfDone = null;
    card.querySelectorAll('.hf-form-feedback').forEach(function(el){ el.classList.remove('is-visible'); });
    card.classList.remove('hf-card--done');
    var ph = card.querySelector('.hf-form-wrap [name="contact[phone]"]');
    if (ph) { ph.focus(); ph.select(); }
  });

  /* Digits only. type="tel" accepts any character — letters and punctuation
     were reaching the lead — and maxlength alone doesn't stop them. Strips on
     every input, which covers paste and autofill as well as typing.

     Deliberately does NOT reformat (no spaces, no +91): stashLeadPhone reads
     this field raw for the Google Ads conversion and normalises it itself, so
     leaving it as bare digits keeps that path identical to what it sees now. */
  card.addEventListener('input', function(e){
    var el = e.target;
    if (!el || !el.classList || !el.classList.contains('hf-phone-inp')) return;
    var before  = el.value;
    var cleaned = before.replace(/\D/g, '').slice(0, 10);
    if (cleaned === before) return;
    /* Hold the caret where the customer was rather than throwing them to the
       end of the field, which makes correcting a middle digit impossible. */
    var caret   = el.selectionStart;
    var stripped = (before.slice(0, caret).match(/\D/g) || []).length;
    el.value = cleaned;
    var pos = Math.max(0, Math.min(caret - stripped, cleaned.length));
    try { el.setSelectionRange(pos, pos); } catch (err) {}
  });

  /* Paste needs its own pass. maxlength truncates the clipboard text before the
     input event above can see it, so "+91 98765 43210" would arrive already
     chopped to "+91 987654" and clean down to nine wrong digits. Strip first,
     then keep the LAST ten — the same rule stashLeadPhone applies — so a pasted
     country code falls off the front instead of eating the real number. */
  card.addEventListener('paste', function(e){
    var el = e.target;
    if (!el || !el.classList || !el.classList.contains('hf-phone-inp')) return;
    var clip = e.clipboardData || window.clipboardData;
    if (!clip) return;
    e.preventDefault();
    var digits = String(clip.getData('text') || '').replace(/\D/g, '');
    if (!digits) return;
    var merged = (el.value.slice(0, el.selectionStart) + digits +
                  el.value.slice(el.selectionEnd)).replace(/\D/g, '');
    if (merged.length > 10) merged = merged.slice(-10);
    el.value = merged;
    try { el.setSelectionRange(merged.length, merged.length); } catch (err) {}
  });

  /* ── TABS ────────────────────────────────────────────────────── */
  tabs.forEach(function(btn){
    btn.addEventListener('click', function(){
      var mode = btn.dataset.mode;
      if (!mode) return;
      activeMode = mode;
      tabs.forEach(function(b){ b.classList.remove('hf-tab--active'); });
      btn.classList.add('hf-tab--active');
      Object.keys(formWraps).forEach(function(k){
        if (formWraps[k]) formWraps[k].style.display = (k === mode) ? 'block' : 'none';
      });
      syncModeLabels();
      syncModeUI();
      updateTicker();
      refreshPickers();
      calculate();
    });
  });

  /* Which column of the rate table a tab quotes from. Remittance quotes the
     interbank mid itself — zero markup — so this is the one place the three
     surfaces diverge. */
  function rateKey(){ return activeMode === 'sell' ? 'sell' : activeMode === 'send' ? 'remit' : 'buy'; }

  /* ── Product-aware buy pricing ─────────────────────────────────
     The buy tab quotes from TWO books since Aug 2026: currency notes
     (`buy`) and the cheaper forex card (`card`, new column in rates.js).
     Which one applies is whatever "How do you want it?" pill is checked:
       Cash Only   → buy          Forex Card → card
       Card + Cash → indicative 50/50 blend of the two
     Falls back to the cash rate while a stale (pre-v7) cached table has
     no card column. Sell/Send are untouched. */
  function svcSelected(){
    var el = card.querySelector('#hfBuyForm [name="contact[service]"]:checked');
    /* Fallback mirrors the `checked` radio in the markup above. */
    return el ? el.value : 'Cash Only';
  }
  function cardRateOf(rec){ return (rec.card != null) ? rec.card : rec.buy; }
  function buyRateFor(rec){
    if (!rec) return null;
    var svc = svcSelected();
    if (svc === 'Forex Card')  return cardRateOf(rec);
    if (svc === 'Card + Cash') return (cardRateOf(rec) + rec.buy) / 2;
    return rec.buy;
  }
  function rateFor(code){
    var rec = code ? STORE.table[code] : null;
    if (!rec) return null;
    return activeMode === 'buy' ? buyRateFor(rec) : rec[rateKey()];
  }

  /* Paint the live rate on each service pill and the one-line saving vs
     cash. Runs from calculate(), so every path that reprices the card
     (typing, currency change, tab change, pill change, rates landing)
     repaints the pills too. */
  function syncServiceRates(){
    var code = selCurrency ? selCurrency.value : '';
    var rec  = code ? STORE.table[code] : null;
    var dp   = code ? rateDp(code) : 2;
    card.querySelectorAll('[data-hf-svc-rate]').forEach(function(el){
      var kind = el.getAttribute('data-hf-svc-rate');
      if (!rec) { el.textContent = '—'; return; }
      var v = kind === 'card' ? cardRateOf(rec)
            : kind === 'mix'  ? (cardRateOf(rec) + rec.buy) / 2
            : rec.buy;
      el.textContent = (kind === 'mix' ? '≈ ' : '') + '₹' + v.toFixed(dp);
    });
    /* "Best rate" must be true to be worn: hide the badge for any currency
       where the card doesn't actually beat cash (JPY, as priced Aug 2026 —
       its CARD_MARGINS entry sits above the cash margin by the desk's own
       call). Shown by default while rates are still loading. */
    var badge = card.querySelector('.hf-pill__badge');
    if (badge) badge.hidden = !!(rec && cardRateOf(rec) >= rec.buy);
    var saveEl = card.querySelector('[data-hf-save]');
    if (saveEl){
      var amount = inpAmount ? parseFloat(inpAmount.value) || 0 : 0;
      var save = (rec && amount > 0) ? (rec.buy - buyRateFor(rec)) * amount : 0;
      if (activeMode === 'buy' && save >= 1){
        var b = saveEl.querySelector('b');
        if (b) b.textContent = '₹' + Math.round(save).toLocaleString('en-IN');
        saveEl.hidden = false;
      } else {
        saveEl.hidden = true;
      }
    }
  }

  /* ── TICKER ──────────────────────────────────────────────────── */
  function updateTicker(){
    if (!elMarquee) return;

    /* Remittance is priced separately from cash/card forex, so the Send tab
       must not show any exchange-rate figure. Swap the scrolling rates for a
       plain statement instead of leaving numbers that don't apply. */
    if (elTickerLabel) elTickerLabel.textContent = 'LIVE RATES';

    if (STORE.failed && !ratesReady()) {
      elMarquee.innerHTML = '<span class="hf-ticker-item hf-ticker-item--muted">Rates unavailable — request a custom quote</span>';
      return;
    }

    var key   = rateKey();
    var codes = Object.keys(STORE.table).filter(function(c){
      return ALLOWED.has(c) && STORE.table[c][key] != null;
    });
    if (!codes.length) return;
    var html = codes.map(function(code){
      var r = STORE.table[code][key];
      return '<span class="hf-ticker-item"><span style="color:#02e375;margin-right:3px">'+code+'</span>₹'+r.toFixed(rateDp(code))+'</span>';
    }).join('');
    elMarquee.innerHTML = html + html;
  }

  /* ── CONVERTER ───────────────────────────────────────────────── */
  var converterBound = false;
  /* First-paint defaults. Above every per-currency minimum for USD. */
  var SEED_CCY = 'USD', seeded = false;
  function initConverter(){
    if (!selCurrency) return;
    var prev = selCurrency.value;
    selCurrency.innerHTML = '<option value="" disabled' + (prev ? '' : ' selected') + '>Select</option>';
    var all    = Object.keys(STORE.table).filter(function(c){ return ALLOWED.has(c); }).sort();
    var sorted = Array.from(new Set(POPULAR.filter(function(c){ return !!STORE.table[c]; }).concat(all)));
    sorted.forEach(function(code){
      var o = document.createElement('option');
      o.value = code; o.textContent = code;
      if (code === prev) o.selected = true;
      selCurrency.appendChild(o);
    });
    /* Seed the calculator so the card arrives alive rather than as an empty
       shell with a greyed-out button — Wise and Niyo both prefill for the same
       reason. Only ever on first paint; a user's own pick is never overwritten. */
    if (!seeded && !prev && STORE.table[SEED_CCY]) {
      seeded = true;
      selCurrency.value = SEED_CCY;   /* amount stays empty; the rate shows regardless */
    }

    if (!converterBound){
      selCurrency.addEventListener('change', calculate);
      if (inpAmount) inpAmount.addEventListener('input', calculate);
      converterBound = true;
    }
    refreshPickers();
    calculate();
  }

  /* meetsMinimum — single source of truth for the order-size gate.
     Both calculate() and validateForm() read from this so they can
     never disagree. */
  function meetsMinimum(){
    var code   = selCurrency ? selCurrency.value : '';
    var amount = inpAmount ? parseFloat(inpAmount.value) || 0 : 0;
    if (!code) return false;
    /* Send Money: flat 200 minimum in the foreign currency. Buy/Sell keep their per-currency sizes. */
    var minReq = (activeMode === 'send') ? 200 : (MIN_QTY[code] || DEFAULT_MIN);
    return amount >= minReq;
  }

  function calculate(){
    if (!selCurrency || !inpAmount || !elValue || !elRate) return;

    var code   = selCurrency.value;
    var amount = parseFloat(inpAmount.value) || 0;
    var rec    = code ? STORE.table[code] : null;

    /* Keep the service pills' rates and the saving line in step with
       every repricing path, including the early returns below. */
    syncServiceRates();

    /* Standing minimum hint next to the amount label, so the rule is
       visible BEFORE the user types rather than only after. */
    var minReq = (activeMode === 'send') ? 200 : (MIN_QTY[code] || DEFAULT_MIN);
    card.querySelectorAll('[data-hf-min-hint]').forEach(function(el){
      el.textContent = code ? ('Min ' + minReq.toLocaleString('en-IN') + ' ' + code) : '';
    });
    card.querySelectorAll('[data-hf-ccy]').forEach(function(el){ el.textContent = code || '\u2014'; });

    /* Empty amount still shows the rate. A blank "1 USD = ₹--" is the worst
       thing on the card — the rate is the whole pitch, so it is always on. */
    if (!rec || amount <= 0){
      elValue.textContent = '0';
      var r0 = rec ? rateFor(code) : null;
      elRate.textContent = (r0 == null) ? '--' : r0.toFixed(rateDp(code));
      if (warnEl) warnEl.hidden = true;
      refreshActiveForm();
      return;
    }

    // Live calculation, from whichever book this tab quotes
    var rate = rateFor(code);
    if (rate == null){
      elValue.textContent = '0.00';
      elRate.textContent  = '--';
      refreshActiveForm();
      return;
    }
    var total = amount * rate;
    elValue.textContent = total.toLocaleString('en-IN', { minimumFractionDigits:2, maximumFractionDigits:2 });
    elRate.textContent  = rate.toFixed(rateDp(code));

    // Minimum warning text only — NEVER touch .disabled here
    if (amount < minReq){
      if (line1) line1.textContent = 'Minimum order: ' + minReq.toLocaleString('en-IN') + ' ' + code;
      if (line2) line2.textContent = '';   // single line during typing
      if (warnEl) warnEl.hidden = false;
    } else {
      if (warnEl) warnEl.hidden = true;
    }

    // Hand button state to the one owner
    refreshActiveForm();
  }

  /* Ask the currently visible form to re-evaluate its button.
     This is the ONLY bridge between the converter and button state. */
  function refreshActiveForm(){
    var wrap = formWraps[activeMode];
    if (!wrap) return;
    var form = wrap.querySelector('form');
    if (form && formValidators[form.id]) formValidators[form.id]();
  }

  /* ══════════════════════════════════════════════════════════
     SEARCHABLE CURRENCY COMBOBOX
     Replaces the OS-level full-screen <select> picker with an
     in-place panel. #hfFromCurrency is still the value store: the
     panel writes to it and dispatches `change`, so calculate(),
     buildBody() and every GTM hook keep working untouched.
     ══════════════════════════════════════════════════════════ */
  function initCurrencyPicker(){
    var box     = card.querySelector('.hf-conv-row');   /* panel spans both fields */
    var trigger = card.querySelector('.hf-ccy-trigger');
    var sel     = selCurrency;
    if (!box || !trigger || !sel) return;

    var uid = 'hfCcy' + (++uidSeq);

    var panel = document.createElement('div');
    panel.className = 'hf-ccy-panel';
    panel.id = uid + 'Panel';
    panel.hidden = true;
    panel.innerHTML =
      '<div class="hf-ccy-search-wrap">' +
        '<svg class="hf-ccy-search-icon" viewBox="0 0 24 24" aria-hidden="true">' +
          '<circle cx="11" cy="11" r="7" stroke-width="2"/><path d="M20 20l-3.5-3.5" stroke-width="2" stroke-linecap="round"/>' +
        '</svg>' +
        '<input type="text" class="hf-ccy-search" id="' + uid + 'Search" ' +
          'placeholder="Search currency, code or country" autocomplete="off" spellcheck="false" ' +
          'role="combobox" aria-autocomplete="list" aria-expanded="true" aria-controls="' + uid + 'List">' +
      '</div>' +
      '<div class="hf-ccy-list" id="' + uid + 'List" role="listbox" aria-label="Currencies"></div>';
    box.appendChild(panel);

    trigger.setAttribute('aria-controls', panel.id);

    var search   = panel.querySelector('.hf-ccy-search');
    var list     = panel.querySelector('.hf-ccy-list');
    var elFlag   = trigger.querySelector('.hf-ccy-trigger__flag');
    var elCode   = trigger.querySelector('.hf-ccy-trigger__code');
    var activeIx = -1;
    var rows     = [];

    function rowHtml(code, i){
      var meta = CCY[code] || { n:code, f:'💱' };
      var rec  = STORE.table[code];
      /* No rate column on the Send tab — remittance is priced separately. */
      var rate = (rec && activeMode !== 'send')
        ? ('₹' + (activeMode === 'sell' ? rec.sell : rec.buy).toFixed(rateDp(code)))
        : '';
      return '<div class="hf-ccy-opt" role="option" id="' + uid + 'Opt' + i + '" ' +
               'data-code="' + code + '" aria-selected="' + (sel.value === code ? 'true' : 'false') + '">' +
               '<span class="hf-ccy-opt__flag" aria-hidden="true">' + meta.f + '</span>' +
               '<span class="hf-ccy-opt__code">' + code + '</span>' +
               '<span class="hf-ccy-opt__name">' + esc(meta.n) + '</span>' +
               '<span class="hf-ccy-opt__rate">' + rate + '</span>' +
             '</div>';
    }

    function render(){
      var q     = norm(search.value);
      var codes = ccyCodes();
      /* Send Money tab: offer only the remittance currencies. */
      if (activeMode === 'send') {
        codes = codes.filter(function(c){ return REMIT_CCY.indexOf(c) !== -1; });
      }
      var html  = '';
      var i     = 0;

      if (!q) {
        /* No query → Popular first, then the rest alphabetically. */
        var pop  = POPULAR.filter(function(c){ return codes.indexOf(c) !== -1; });
        var rest = codes.filter(function(c){ return pop.indexOf(c) === -1; })
                        .sort(function(a,b){ return (CCY[a].n).localeCompare(CCY[b].n); });

        /* Buy/Sell list 28 currencies, so the Popular / All split earns its
           keep. Remittance offers seven — grouping those was just noise. */
        var grouped = (activeMode !== 'send');
        if (grouped) html += '<div class="hf-ccy-group">Popular</div>';
        pop.forEach(function(c){ html += rowHtml(c, i++); });
        if (grouped) html += '<div class="hf-ccy-group">All currencies</div>';
        rest.forEach(function(c){ html += rowHtml(c, i++); });
      } else {
        var hits = codes.map(function(c){ return { c:c, s:scoreCcy(c, q) }; })
                        .filter(function(o){ return o.s > 0; })
                        .sort(function(a,b){
                          if (b.s !== a.s) return b.s - a.s;
                          /* Equal relevance → the currency people actually buy wins.
                             Without this, searching "dollar" buries USD under
                             Australian / Canadian / Hong Kong alphabetically. */
                          var pa = POPULAR.indexOf(a.c), pb = POPULAR.indexOf(b.c);
                          if (pa === -1) pa = 99;
                          if (pb === -1) pb = 99;
                          if (pa !== pb) return pa - pb;
                          return CCY[a.c].n.localeCompare(CCY[b.c].n);
                        });
        if (!hits.length) {
          html = '<div class="hf-ccy-empty">No currency matches “' + esc(search.value.trim()) + '”.<br>Try a code (USD), a name (Thai Baht) or a country.</div>';
        } else {
          hits.forEach(function(o){ html += rowHtml(o.c, i++); });
        }
      }

      list.innerHTML = html;
      rows = Array.prototype.slice.call(list.querySelectorAll('.hf-ccy-opt'));
      /* Pre-highlight the first result so Enter always does something sensible. */
      setActive(rows.length ? 0 : -1, false);
    }

    function setActive(ix, scroll){
      if (activeIx > -1 && rows[activeIx]) rows[activeIx].classList.remove('is-active');
      activeIx = ix;
      if (ix > -1 && rows[ix]) {
        rows[ix].classList.add('is-active');
        search.setAttribute('aria-activedescendant', rows[ix].id);
        if (scroll !== false) {
          var r = rows[ix], l = list;
          if (r.offsetTop < l.scrollTop) l.scrollTop = r.offsetTop - 4;
          else if (r.offsetTop + r.offsetHeight > l.scrollTop + l.clientHeight) {
            l.scrollTop = r.offsetTop + r.offsetHeight - l.clientHeight + 6;
          }
        }
      } else {
        search.removeAttribute('aria-activedescendant');
      }
    }

    function syncTrigger(){
      var code = sel.value;
      if (code && CCY[code]) {
        elFlag.textContent = CCY[code].f;
        elCode.textContent = code;
        trigger.classList.add('has-value');
      } else {
        elFlag.textContent = '🌐';
        elCode.textContent = 'Select';
        trigger.classList.remove('has-value');
      }
    }

    function open(){
      if (!panel.hidden) return;
      closeAllPanels();
      /* Make room underneath before showing it, so it opens downwards. */
      ensureRoomBelow(box);
      /* Portal into <body> so no ancestor's overflow can clip the list. */
      if (panel.parentNode !== document.body) document.body.appendChild(panel);
      panel.hidden = false;
      box.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      search.value = '';
      render();
      positionPanel(panel, box);
      /* Land on the current selection when reopening. */
      var cur = rows.findIndex ? rows.findIndex(function(r){ return r.dataset.code === sel.value; }) : -1;
      if (cur > -1) setActive(cur, true);
      try { search.focus({ preventScroll:true }); } catch(e){ search.focus(); }
    }

    function close(focusBack){
      if (panel.hidden) return;
      panel.hidden = true;
      box.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      if (focusBack) { try { trigger.focus({ preventScroll:true }); } catch(e){ trigger.focus(); } }
    }

    function choose(code){
      if (!code) return;
      /* Make sure the option exists even if rates haven't landed yet —
         otherwise assigning .value on a <select> silently no-ops. */
      if (!Array.prototype.some.call(sel.options, function(o){ return o.value === code; })) {
        var o = document.createElement('option');
        o.value = code; o.textContent = code;
        sel.appendChild(o);
      }
      sel.value = code;
      sel.dispatchEvent(new Event('change', { bubbles:true }));
      syncTrigger();
      close(true);
      /* Amount is the natural next step. */
      if (inpAmount && !inpAmount.value) { try { inpAmount.focus({ preventScroll:true }); } catch(e){} }
    }

    /* — events — */
    trigger.addEventListener('click', function(e){
      e.preventDefault();
      panel.hidden ? open() : close(true);
    });
    trigger.addEventListener('keydown', function(e){
      if (e.key === 'ArrowDown' || e.key === 'Down') { e.preventDefault(); open(); }
    });

    search.addEventListener('input', render);
    search.addEventListener('keydown', function(e){
      if (e.key === 'ArrowDown' || e.key === 'Down') {
        e.preventDefault();
        if (rows.length) setActive(activeIx < rows.length - 1 ? activeIx + 1 : 0, true);
      } else if (e.key === 'ArrowUp' || e.key === 'Up') {
        e.preventDefault();
        if (rows.length) setActive(activeIx > 0 ? activeIx - 1 : rows.length - 1, true);
      } else if (e.key === 'Enter') {
        e.preventDefault();
        if (activeIx > -1 && rows[activeIx]) choose(rows[activeIx].dataset.code);
      } else if (e.key === 'Escape' || e.key === 'Esc') {
        e.preventDefault(); e.stopPropagation();
        close(true);
      } else if (e.key === 'Tab') {
        close(false);
      } else if (e.key === 'Home') {
        if (rows.length) { e.preventDefault(); setActive(0, true); }
      } else if (e.key === 'End') {
        if (rows.length) { e.preventDefault(); setActive(rows.length - 1, true); }
      }
    });

    list.addEventListener('mousedown', function(e){
      /* mousedown, not click — beats the document-level outside-close. */
      var opt = e.target.closest('.hf-ccy-opt');
      if (!opt) return;
      e.preventDefault();
      choose(opt.dataset.code);
    });
    list.addEventListener('mousemove', function(e){
      var opt = e.target.closest('.hf-ccy-opt');
      if (!opt) return;
      var ix = rows.indexOf(opt);
      if (ix > -1 && ix !== activeIx) setActive(ix, false);
    });

    sel.addEventListener('change', syncTrigger);

    /* Registered so new rates — and a tab change — repaint the rate column
       and the trigger. Repaints even while closed, so a stale rate is never
       left sitting in the markup after switching to the Send tab. */
    pickerRefreshers.push(function(){
      /* Send tab offers only the remittance currencies — clear an invalid carried-over pick. */
      if (activeMode === 'send' && sel.value &&
          REMIT_CCY.indexOf(sel.value) === -1) {
        sel.value = '';
        sel.dispatchEvent(new Event('change', { bubbles:true }));
      }
      syncTrigger();
      if (panel.hidden) {
        search.value = '';
        render();
      } else {
        var keep = search.value;
        render();
        search.value = keep;
      }
    });

    openPanels.push({ close: function(){ close(false); }, el: panel, host: box });
    trackPanel(panel, box);
    syncTrigger();
  }

  /* ══════════════════════════════════════════════════════════
     CITY PICKER — the 8 branch service areas
     The <input name="contact[city]"> stays a real, required, focusable
     input (readonly) so Shopify validation and GTM see no change.
     ══════════════════════════════════════════════════════════ */
  function initCityPicker(wrap){
    var input = wrap.querySelector('.hf-city-inp');
    if (!input) return;

    var uid = 'hfCity' + (++uidSeq);

    var panel = document.createElement('div');
    panel.className = 'hf-city-panel';
    panel.id = uid + 'Panel';
    panel.hidden = true;

    var html = '<div class="hf-city-panel__head">Select your city</div><div class="hf-city-list" role="listbox" aria-label="Cities">';
    CITIES.forEach(function(c, i){
      html += '<div class="hf-city-opt" role="option" id="' + uid + 'Opt' + i + '" ' +
                'data-label="' + esc(c.label) + '" aria-selected="false">' +
                '<svg class="hf-city-opt__pin" viewBox="0 0 24 24" aria-hidden="true">' +
                  '<path d="M12 21s7-6.2 7-11a7 7 0 1 0-14 0c0 4.8 7 11 7 11Z"/><circle cx="12" cy="10" r="2.6"/>' +
                '</svg>' +
                '<span>' + esc(c.label) + '</span>' +
                '<svg class="hf-city-opt__tick" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 13l4 4L19 7" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
              '</div>';
    });
    html += '</div>';
    panel.innerHTML = html;
    wrap.appendChild(panel);

    input.setAttribute('aria-controls', panel.id);

    var list     = panel.querySelector('.hf-city-list');
    var rows     = Array.prototype.slice.call(panel.querySelectorAll('.hf-city-opt'));
    var activeIx = -1;

    function setActive(ix){
      if (activeIx > -1 && rows[activeIx]) rows[activeIx].classList.remove('is-active');
      activeIx = ix;
      if (ix > -1 && rows[ix]) {
        rows[ix].classList.add('is-active');
        input.setAttribute('aria-activedescendant', rows[ix].id);
        var r = rows[ix];
        if (r.offsetTop < list.scrollTop) list.scrollTop = r.offsetTop - 4;
        else if (r.offsetTop + r.offsetHeight > list.scrollTop + list.clientHeight) {
          list.scrollTop = r.offsetTop + r.offsetHeight - list.clientHeight + 6;
        }
      } else {
        input.removeAttribute('aria-activedescendant');
      }
    }

    function syncSelected(){
      rows.forEach(function(r){
        r.setAttribute('aria-selected', r.dataset.label === input.value ? 'true' : 'false');
      });
    }

    function open(){
      if (!panel.hidden) return;
      closeAllPanels();
      /* Make room underneath before showing it, so it opens downwards. */
      ensureRoomBelow(wrap);
      /* Portal into <body> so no ancestor's overflow can clip the list. */
      if (panel.parentNode !== document.body) document.body.appendChild(panel);
      panel.hidden = false;
      wrap.classList.add('is-open');
      input.setAttribute('aria-expanded', 'true');
      positionPanel(panel, wrap);
      syncSelected();
      var cur = -1;
      rows.forEach(function(r, i){ if (r.dataset.label === input.value) cur = i; });
      setActive(cur > -1 ? cur : 0);
    }

    function close(focusBack){
      if (panel.hidden) return;
      panel.hidden = true;
      wrap.classList.remove('is-open');
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      if (focusBack) { try { input.focus({ preventScroll:true }); } catch(e){ input.focus(); } }
    }

    function choose(label){
      input.value = label;
      /* `input` re-runs setupFormValidation, `change` covers anything
         else listening (including GTM field-change triggers). */
      input.dispatchEvent(new Event('input',  { bubbles:true }));
      input.dispatchEvent(new Event('change', { bubbles:true }));
      syncSelected();
      close(true);
    }

    input.addEventListener('mousedown', function(e){
      e.preventDefault();          /* readonly inputs shouldn't show a caret */
      panel.hidden ? open() : close(false);
      try { input.focus({ preventScroll:true }); } catch(err){}
    });
    input.addEventListener('keydown', function(e){
      if (e.key === 'ArrowDown' || e.key === 'Down') {
        e.preventDefault();
        if (panel.hidden) open(); else setActive(activeIx < rows.length - 1 ? activeIx + 1 : 0);
      } else if (e.key === 'ArrowUp' || e.key === 'Up') {
        e.preventDefault();
        if (panel.hidden) open(); else setActive(activeIx > 0 ? activeIx - 1 : rows.length - 1);
      } else if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        if (panel.hidden) open();
        else if (activeIx > -1) choose(rows[activeIx].dataset.label);
      } else if (e.key === 'Escape' || e.key === 'Esc') {
        if (!panel.hidden) { e.preventDefault(); e.stopPropagation(); close(true); }
      } else if (e.key === 'Tab') {
        close(false);
      }
    });

    list.addEventListener('mousedown', function(e){
      var opt = e.target.closest('.hf-city-opt');
      if (!opt) return;
      e.preventDefault();
      choose(opt.dataset.label);
    });
    list.addEventListener('mousemove', function(e){
      var opt = e.target.closest('.hf-city-opt');
      if (!opt) return;
      var ix = rows.indexOf(opt);
      if (ix > -1 && ix !== activeIx) setActive(ix);
    });

    openPanels.push({ close: function(){ close(false); }, el: panel, host: wrap });
    trackPanel(panel, wrap);
    syncSelected();
  }

  /* ── BUILD BODY — serialises EVERYTHING into one readable string ─
     This is what appears in Shopify's notification email.
     Format is plain-text so it reads clearly in any email client.
  ───────────────────────────────────────────────────────────────── */
  function buildBody(formEl, formType){
    var q  = function(name){ return (formEl.querySelector('[name="contact['+name+']"]') || {}).value || ''; };
    var qr = function(name){ var el = formEl.querySelector('[name="contact['+name+']"]:checked'); return el ? el.value : ''; };

    /* Calculator snapshot. Remittance now quotes from its own book rather than
       being priced on enquiry, so a Send lead carries its rate and total too —
       the desk needs to see the number the customer was actually shown. */
    var currency = selCurrency ? selCurrency.value : '';
    var amount   = inpAmount   ? inpAmount.value   : '';
    var rate     = elRate  ? elRate.textContent  : '';
    var total    = elValue ? elValue.textContent : '';


    /* ── Formatting helpers ────────────────────────────────────────── */

    /* Real bold isn't available — Shopify's contact-form template renders the
       body as plain text. These are Unicode "mathematical sans-serif bold"
       characters: ordinary characters that happen to look bold, so they
       survive any client. Set BOLD_HEADINGS = false for plain capitals. */
    var BOLD_HEADINGS = true;
    var bold = function(str){
      if (!BOLD_HEADINGS) return str;
      return String(str).replace(/[A-Za-z0-9]/g, function(c){
        var n = c.charCodeAt(0);
        if (n >= 65 && n <= 90)  return String.fromCodePoint(0x1D5D4 + n - 65);  /* A–Z */
        if (n >= 97 && n <= 122) return String.fromCodePoint(0x1D5EE + n - 97);  /* a–z */
        return String.fromCodePoint(0x1D7EC + n - 48);                            /* 0–9 */
      });
    };

    /* Pads every label in a block to the same width so the colons line up.
       The body renders in a proportional font so this can't be pixel-exact,
       but an even left edge still reads far better than a ragged one. */
    var block = function(rows){
      var width = 0, out = [];
      rows.forEach(function(r){ if (r[1] !== '' && r[1] != null && r[0].length > width) width = r[0].length; });
      rows.forEach(function(r){
        if (r[1] === '' || r[1] == null) return;
        var label = r[0];
        while (label.length < width) label += ' ';
        out.push(label + ' : ' + r[1]);
      });
      return out;
    };

    /* Plain 10 digits — no country code, no spacing. Keeps it selectable as
       one token for dialling and matches what Shopify prints further down. */
    var fmtPhone = function(v){
      var d = String(v || '').replace(/\D/g, '');
      return d.length > 10 ? d.slice(-10) : (d || String(v || ''));
    };
    var fmtAmount = function(v){
      var n = parseFloat(v);
      return isNaN(n) ? (v || '') : n.toLocaleString('en-IN', { maximumFractionDigits: 2 });
    };

    /* What the team calls these internally, which is not what the tab labels
       say. Tab labels are GTM-visible and stay exactly as they are. */
    var KIND = { hfBuyForm:'Buy Forex', hfSellForm:'Sell Forex', hfSendForm:'Remittance' };
    var kind = KIND[formEl.id] || 'Lead';

    var svc = qr('service');

    /* The rate the customer was shown rides on the summary line only —
       "2,695 USD @ ₹96.4750" — so it is visible from the inbox list. Inside
       the block the amount stands on its own. Remittance is quoted on
       enquiry and never carries a rate at all. */
    var qty = ((amount ? fmtAmount(amount) : '') + (currency ? ' ' + currency : '')).trim();
    var qtyRate = qty + (rate ? ' @ ₹' + rate : '');
    /* Summary line keeps grouped digits — it is read, not copied. */
    if (total) qtyRate += ' · ₹' + total;

    /* The CONTACT block is copied into the desk's system, so its figures go in
       plain: no thousands separators to strip out by hand, and no rate or total
       either — both are already on the summary line above. */
    var plain    = function(v){ return String(v || '').replace(/,/g, ''); };
    var qtyPlain = ((amount ? plain(fmtAmount(amount)) : '') + (currency ? ' ' + currency : '')).trim();

    var lines = [];

    /* Shopify's subject is fixed ("New customer message on …"), so this first
       line is what shows as the preview in the inbox list. Who, where, how
       much, at what rate — enough to triage without opening the mail. */
    lines.push([q('name'), q('city'), qtyRate, svc].filter(Boolean).join(' · '));
    lines.push('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
    lines.push('');

    lines.push(bold('CONTACT — ' + kind.toUpperCase()));
    lines = lines.concat(block([
      ['Name',    q('name')],
      ['Phone',   fmtPhone(q('phone'))],
      ['Email',   q('email')],
      ['City',    q('city')],
      ['Amount',  qtyPlain],
      ['Product', svc],
      ['Purpose', q('purpose')]
    ]));

    lines.push('');
    lines.push(bold('LEAD SOURCE'));
    var campId = trackingData.gad_campaignid || trackingData.campaign_id || trackingData.cid;
    var plainLabel = function (s) {
      /* Shopify's contact-form filter discards any submission whose body carries a
         URL or a host.tld, because hosts like www.google.com appear across the whole
         platform (Shopify Specialist Support, 7 Sep 2026). Labels stay readable but
         never in domain format: "Campaign: chatgpt.com" becomes "Campaign: chatgpt com". */
      return String(s || '')
        .replace(/[a-z][a-z0-9+.\-]*:\/\/+/gi, '')
        .replace(/\b([a-z0-9\-]+)((?:\.[a-z0-9\-]+)+)\b/gi, function (m, a, b) { return a + b.replace(/\./g, ' '); })
        .replace(/\/+\s*$/, '')
        .replace(/\s+/g, ' ').replace(/^\s+|\s+$/g, '');
    };
    /* No Referrer line at all, on Shopify Specialist Support's finding of
       7 Sep 2026: even the bare hostname (www.google.com) is parsed as a URL
       by their content filter and the submission is discarded; every
       submission without the line delivered, every one with it did not. The
       vault still records the full referrer for our own email and register. */
    lines = lines.concat(block([
      ['Source',       plainLabel(classifySource())],
      ['Campaign ID',  campId || ''],
      ['UTM Source',   plainLabel(trackingData.utm_source || '')],
      ['UTM Medium',   plainLabel(trackingData.utm_medium || '')],
      ['UTM Campaign', plainLabel(trackingData.utm_campaign || '')],
      ['UTM Content',  plainLabel(trackingData.utm_content || '')],
      ['UTM Term',     plainLabel(trackingData.utm_term || '')],
      ['Landing page', window.location.pathname],
      /* Click IDs last — unreadable, but needed for offline conversion
         import, so they are kept in full rather than truncated. */
      ['GCLID',        trackingData.gclid || ''],
      ['GBRAID',       trackingData.gbraid || ''],
      ['WBRAID',       trackingData.wbraid || ''],
      ['FBCLID',       trackingData.fbclid || ''],
      ['RDT_CID',      trackingData.rdt_cid || ''],
      ['OPPREF',       trackingData.oppref || '']
    ]));

    return lines.join('\n');
  }

  /* Minimum-order gate — runs in CAPTURE phase so it beats every other handler.
     Belt-and-braces: even though the button is disabled when invalid, this
     guards against any programmatic submit and serialises the body on success. */
  function gateSubmit(e) {
    var formEl = this;
    var isSend = (formEl.id === 'hfSendForm');
    var code   = selCurrency ? selCurrency.value : '';
    var amount = inpAmount   ? parseFloat(inpAmount.value) || 0 : 0;
    var minReq = MIN_QTY[code] || DEFAULT_MIN;

    /* Send: require a currency + the flat 200 minimum before building the body. */
    if (isSend) {
      if (!code || amount < 200) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (line1) line1.textContent = code ? ('Minimum send amount: 200 ' + code) : 'Please select a currency before submitting.';
        if (line2) line2.textContent = code ? ('You entered ' + amount + ' ' + code) : '';
        if (warnEl) warnEl.hidden = false;
        if (code && inpAmount) { inpAmount.focus(); inpAmount.select(); }
        return false;
      }
      normaliseCityForSubmit(formEl);
      var sendBody = card.querySelector('#' + formEl.dataset.hfBody);
      if (sendBody) sendBody.value = buildBody(formEl, formEl.dataset.hfType);
      stashLeadPhone(formEl);
      return;
    }

    if (!code) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (line1) line1.textContent = 'Please select a currency before submitting.';
      if (line2) line2.textContent = '';
      if (warnEl) warnEl.hidden = false;
      var trg = card.querySelector('.hf-ccy-trigger');
      if (trg) trg.focus();
      return false;
    }
    if (amount < minReq) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (line1) line1.textContent = 'Minimum order: ' + minReq.toLocaleString('en-IN') + ' ' + code;
      if (line2) line2.textContent = 'You entered ' + amount + ' ' + code;
      if (warnEl) warnEl.hidden = false;
      if (inpAmount) { inpAmount.focus(); inpAmount.select(); }
      return false;
    }

    /* City gate. The picker input is readonly, and readonly controls are
       barred from HTML constraint validation — so `required` alone would
       not stop an empty city here. The disabled submit button is the first
       line of defence; this is the second. */
    var cityEl = formEl.querySelector('[name="contact[city]"]');
    if (cityEl && !cityEl.value.trim()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (line1) line1.textContent = 'Please select your city before submitting.';
      if (line2) line2.textContent = '';
      if (warnEl) warnEl.hidden = false;
      cityEl.focus();
      return false;
    }

    normaliseCityForSubmit(formEl);
    var bodyEl = card.querySelector('#' + formEl.dataset.hfBody);
    if (bodyEl) bodyEl.value = buildBody(formEl, formEl.dataset.hfType);
    stashLeadPhone(formEl);
  }

  var formDefs = [
    { id:'hfBuyForm',  bodyId:'hfBodyBuy',  type:'Book Forex Lead'  },
    { id:'hfSellForm', bodyId:'hfBodySell', type:'Sell Forex Lead' },
    { id:'hfSendForm', bodyId:'hfBodySend', type:'Send Money Lead' }
  ];

  formDefs.forEach(function(def){
    var formEl = card.querySelector('#' + def.id);
    if (!formEl) return;
    /* Tag the form with the IDs/types we need at submit-time */
    formEl.dataset.hfBody = def.bodyId;
    formEl.dataset.hfType = def.type;
    /* Capture-phase + stopImmediatePropagation = no other handler can override */
    formEl.addEventListener('submit', gateSubmit, true);
  });

  /* ── FORM VALIDATION — SINGLE OWNER of submitBtn.disabled ─────────
     validateForm() is the ONLY place that writes submitBtn.disabled.
     It checks both the required fields AND the minimum-order gate,
     so the converter and the field validation can never disagree. */
  function setupFormValidation(formId, submitSelector) {

    var form = card.querySelector('#' + formId);
    if (!form) return;

    var submitBtn = form.querySelector(submitSelector);
    if (!submitBtn) return;

    var requiredFields = form.querySelectorAll(
      'input[required], select[required], textarea[required]'
    );

    function isFilled(el) {
      if (el.type === 'checkbox') return el.checked;
      if (el.type === 'radio') {
        return !!form.querySelector('[name="' + el.name + '"]:checked');
      }
      return el.value.trim() !== '';
    }

    function validateForm() {
      /* Calculator gate only. Blocking on the contact fields too left the
         primary CTA dead on arrival, which reads as broken; the fields are
         still enforced at click below, so nothing incomplete gets through. */
      var valid = meetsMinimum();
      submitBtn.disabled = !valid;
      submitBtn.classList.toggle('hf-submit--disabled', !valid);
    }

    /* Contact-field check at click: mark what's missing and focus it. */
    form.addEventListener('submit', function(e){
      var firstBad = null;
      requiredFields.forEach(function(field){
        var bad = !isFilled(field);
        field.classList.toggle('hf-inp--error', bad);
        if (bad && !firstBad) firstBad = field;
      });
      if (firstBad) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (firstBad.type !== 'checkbox') firstBad.focus();
        return false;
      }
    }, true);

    requiredFields.forEach(function(field){
      field.addEventListener('input',  function(){ field.classList.remove('hf-inp--error'); });
      field.addEventListener('change', function(){ field.classList.remove('hf-inp--error'); });
    });

    requiredFields.forEach(function(field) {
      field.addEventListener('input', validateForm);
      field.addEventListener('change', validateForm);
    });

    /* Register so calculate()/refreshActiveForm() can trigger it */
    formValidators[formId] = validateForm;

    validateForm();
  }

  /* ── CARD BOOT ───────────────────────────────────────────────── */
  initCurrencyPicker();
  card.querySelectorAll('.hf-city-wrap').forEach(initCityPicker);

  /* Service pills reprice the buy tab live. `change` only — GTM triggers
     listening on these radios see exactly the same events as before. */
  card.querySelectorAll('#hfBuyForm [name="contact[service]"]').forEach(function(r){
    r.addEventListener('change', calculate);
  });

  setupFormValidation('hfBuyForm', '.hf-submit');
  setupFormValidation('hfSellForm', '.hf-submit');
  setupFormValidation('hfSendForm', '.hf-submit');

  syncModeLabels();
  syncModeUI();
  updateTicker();

  /* Repaint whenever the shared rate store changes. */
  onRates(function(){
    updateTicker();
    initConverter();
    if (elUpdated && STORE.updated) elUpdated.textContent = STORE.updated;
  });
}

/* ══════════════════════════════════════════════════════════════
   PAGE-LEVEL SETUP — runs once, however many cards are on the page
   ══════════════════════════════════════════════════════════════ */
if (!window.__hfPageInit) {
  window.__hfPageInit = true;

  /* ── POST-SUBMIT feedback ────────────────────────────────────── */
  if (window.location.search.indexOf('contact_posted=true') !== -1){
    /* Record which tab was submitted and the number we'll be calling, then
       let initCard() apply it. This block runs BEFORE the cards are wired up,
       so anything that needs a live tab handler has to happen there, not here. */
    var hfDoneMode = null, hfDonePhone = null;
    try {
      hfDoneMode  = sessionStorage.getItem('hfLeadMode');
      hfDonePhone = sessionStorage.getItem('hfLeadPhoneShow');
      sessionStorage.removeItem('hfLeadMode');
      sessionStorage.removeItem('hfLeadPhoneShow');
    } catch (err) {}
    window.__hfDone = { mode: hfDoneMode || 'buy', phone: hfDonePhone || '' };

    window.history.replaceState(null, '', window.location.pathname);

    /* Google Ads Enhanced Conversions for Leads — fires once, on the successful
       post-submit reload, using the phone stashed above. Raw E.164; GTM hashes it. */
    try {
      var hfLeadPhone = sessionStorage.getItem('hfLeadPhone');
      if (hfLeadPhone) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'generate_lead', lead_phone: hfLeadPhone });
        sessionStorage.removeItem('hfLeadPhone');
      }
    } catch (err) {}
  }

  /* ── AUTO-DETECT CITY ──────────────────────────────────────────
     Geolocation gives us a raw place name ("Gurgaon", "Thane"),
     which we map onto one of the 8 branch service areas. If it maps
     to nothing we serve, we leave the field empty rather than
     pre-filling a city we can't deliver to.

     Gated behind the first user interaction with a city field. The
     browser must never request geolocation on page load: it prompts
     every visitor unprovoked (poor UX and lost conversions) and fails
     Lighthouse's "geolocation-on-start" best-practice check. This
     mirrors the click-gated pattern in branch-locator.liquid. Runs at
     most once, then fills every card's city field. */
  (function detectCity(){
    if (!navigator.geolocation) return;
    var fields = [].slice.call(document.querySelectorAll('.hf-city-inp, .hf-city-wrap'));
    if (!fields.length) return;
    var done = false;
    function locate(){
      if (done) return; done = true;
      fields.forEach(function(el){
        el.removeEventListener('focusin', locate);
        el.removeEventListener('pointerdown', locate);
      });
      navigator.geolocation.getCurrentPosition(function(pos){
        fetch('https://nominatim.openstreetmap.org/reverse?format=json&lat='+pos.coords.latitude+'&lon='+pos.coords.longitude)
          .then(function(r){ return r.json(); })
          .then(function(d){
            var a = d.address || {};
            var raw = [a.city, a.town, a.suburb, a.county, a.state_district, a.state]
                        .filter(Boolean).join(' ');
            var area = matchServiceArea(raw);
            if (!area) return;
            document.querySelectorAll('.hf-city-inp').forEach(function(inp){
              if (!inp.value) {
                inp.value = area;
                inp.dispatchEvent(new Event('input',  { bubbles:true })); // re-validate
                inp.dispatchEvent(new Event('change', { bubbles:true }));
              }
            });
          }).catch(function(){});
      }, function(){}, {timeout:5000});
    }
    fields.forEach(function(el){
      el.addEventListener('focusin', locate);
      el.addEventListener('pointerdown', locate);
    });
  })();
}

function matchServiceArea(raw){
  var s = norm(raw);
  if (!s) return '';
  for (var i = 0; i < CITIES.length; i++) {
    var keys = CITIES[i].k.split(' ');
    for (var j = 0; j < keys.length; j++) {
      if (keys[j] && s.indexOf(keys[j]) > -1) return CITIES[i].label;
    }
  }
  return '';
}

/* ── CONSENT MODAL ─────────────────────────────────────────────
   The modal must live at document.body level so position:fixed
   isn't trapped by backdrop-filter on .hf-hero-card.
   Each render emits one; keep the first and drop the rest.       */
(function () {
  var modal = document.getElementById('hfConsentModal');
  if (!modal) return;

  /* If multiple hero-forms render on the same page, keep only the
     first modal and remove duplicates (invalid duplicate IDs).   */
  document.querySelectorAll('#hfConsentModal').forEach(function (m, i) {
    if (i > 0) m.parentNode.removeChild(m);
  });

  /* Move to body so it escapes any backdrop-filter containing block */
  if (modal.parentNode !== document.body) document.body.appendChild(modal);

  if (window.__hfConsentBound) return;
  window.__hfConsentBound = true;

  function open()  { modal.classList.add('active'); document.body.style.overflow = 'hidden'; }
  function close() {
    var m = document.getElementById('hfConsentModal');
    if (m) m.classList.remove('active');
    document.body.style.overflow = '';
  }

  /* Delegated open: works for any current OR future trigger */
  document.addEventListener('click', function (e) {
    var trig = e.target.closest('[data-hf-consent-open]');
    if (trig) { e.preventDefault(); open(); return; }
    if (e.target.closest('.hf-consent-modal__close')) { e.preventDefault(); close(); return; }
    if (e.target.classList && e.target.classList.contains('hf-consent-modal__overlay')) { close(); }
  });

  document.addEventListener('click', function (e) {
    var pop = document.getElementById('hfPop');
    if (pop && !pop.hidden && !e.target.closest('#hfPop') && !e.target.closest('[data-hf-info]')) pop.hidden = true;
  });
  var popX = document.getElementById('hfPopX');
  if (popX) popX.addEventListener('click', function(){ document.getElementById('hfPop').hidden = true; });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });
})();

/* ── BOOT ────────────────────────────────────────────────────────
   Init every card present so far. This script tag sits directly
   after its own card, so on a page with several cards each run
   picks up the one just parsed; the __hfInit guard makes the rest
   no-ops. */
document.querySelectorAll('.hf-hero-card').forEach(initCard);
startRates();
})();

;

(function () {
  'use strict';
  /* LEAD VAULT hook, v3 (4 Sep 2026: acknowledged delivery via MxVault.deliver). v2 (2 Sep 2026). Changes from v1: binds to EVERY hero
     form on the page (pages such as buy-forex and the location pages can
     render more than one card, and duplicate ids meant only the first card
     was vaulted); reads the calculator numbers from the card that owns the
     form; never binds the same form twice when this file is included more
     than once. Payload, endpoint and form labels are unchanged. */
  var VAULT = 'https://matrix-leads.styxified2408.workers.dev/lead';
  var LABELS = { hfBuyForm: 'hero-buy', hfSellForm: 'hero-sell', hfSendForm: 'hero-send' };
  function val(form, n) {
    var el = form.querySelector('[name="contact[' + n + ']"]');
    return el ? el.value : '';
  }
  function checked(form, n) {
    var el = form.querySelector('[name="contact[' + n + ']"]:checked');
    return el ? el.value : '';
  }
  function txt(form, id) {
    var scope = (form.closest && form.closest('.hf-hero-card')) || document;
    var el = scope.querySelector('[id="' + id + '"]') || document.getElementById(id);
    if (!el) return '';
    if (el.tagName === 'INPUT' || el.tagName === 'SELECT') return el.value || '';
    return el.textContent || '';
  }
  function attribution() {
    var t = window.__hfTracking || (window.MxTracking && window.MxTracking.data) || {};
    var label = '';
    try {
      if (window.MxTracking && window.MxTracking.classifySource) label = window.MxTracking.classifySource();
      else if (typeof classifySource === 'function') label = classifySource();
    } catch (e) {}
    var ref = '';
    try { ref = sessionStorage.getItem('mx_first_referrer') || document.referrer || ''; } catch (e) {}
    return {
      src_label: label, campaign_id: t.gad_campaignid || t.campaign_id || t.cid || '',
      utm_source: t.utm_source || '', utm_medium: t.utm_medium || '',
      utm_campaign: t.utm_campaign || '', utm_content: t.utm_content || '',
      utm_term: t.utm_term || '', gclid: t.gclid || '', gbraid: t.gbraid || '',
      wbraid: t.wbraid || '', fbclid: t.fbclid || '', rdt_cid: t.rdt_cid || '',
      oppref: t.oppref || '',
      referrer: ref
    };
  }
  function send(form, label) {
    try {
      var base = {
        form: label,
        name: val(form, 'name'), phone: val(form, 'phone'),
        email: val(form, 'email'), city: val(form, 'city'),
        service: checked(form, 'service') || val(form, 'purpose'),
        currency: txt(form, 'hfFromCurrency'), amount: txt(form, 'hfFromAmount'),
        rate: txt(form, 'hfDisplayRate'), total: txt(form, 'hfConvertedValue'),
        page: location.pathname, source: location.search || ''
      };
      var at = attribution();
      for (var k in at) base[k] = at[k];
      /* v3 (4 Sep 2026): the site-wide sender in mx-tracking.liquid keeps an
         outbox and retries until the worker acknowledges, so a dropped beacon
         no longer loses the lead. The old fire-and-forget stays as a fallback
         for a page where that snippet is somehow missing. */
      if (window.MxVault && typeof window.MxVault.deliver === 'function') { window.MxVault.deliver(base); return; }
      var payload = JSON.stringify(base);
      var queued = false;
      if (navigator.sendBeacon) { try { queued = navigator.sendBeacon(VAULT, payload); } catch (e) { queued = false; } }
      if (!queued) { fetch(VAULT, { method: 'POST', body: payload, keepalive: true }).catch(function () {}); }
    } catch (e) { /* never interfere with the real submit */ }
  }
  function bind(form) {
    if (!form || form.__mxVault) return;
    var label = LABELS[form.id];
    if (!label) return;
    /* the currency-page order form shares the hfBuyForm id; assets/fx.js vaults that one */
    if (form.classList && form.classList.contains('fx-orderform')) return;
    form.__mxVault = true;
    form.addEventListener('submit', function () { send(form, label); });
  }
  function bindAll() {
    var forms = document.querySelectorAll('form[id="hfBuyForm"], form[id="hfSellForm"], form[id="hfSendForm"]');
    for (var i = 0; i < forms.length; i++) bind(forms[i]);
  }
  bindAll();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindAll);
})();
